var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 11-.493 3.939l-3.926 3.49A7 7 0 1012 7v5z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15a1 1 0 10-1-1l-4.39 3.512a.625.625 0 00.78.976l4.39-3.512c.071.016.145.024.22.024z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.375a.625.625 0 100 1.25h1.375v1.887A9.567 9.567 0 006.79 5.906L5.884 5l.558-.558a.625.625 0 10-.884-.884l-2 2a.625.625 0 10.884.884L5 5.884l.775.775a9.625 9.625 0 1012.45 0L19 5.884l.558.558a.625.625 0 10.884-.884l-2-2a.625.625 0 10-.884.884l.558.558-.906.906a9.567 9.567 0 00-3.585-1.394V2.625H15a.625.625 0 100-1.25H9zM3.625 14a8.375 8.375 0 1116.75 0 8.375 8.375 0 01-16.75 0z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get-started.42b8364ac560401dfab2077e416818eb.svg";
export { ForwardRef as ReactComponent };